import { MESApiService, type spParameter } from "@dexteel/mesf-core";

export const getAssetResources = async (AssetId: string | number | undefined) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [];
	parameters.push({
		name: "AssetId",
		value: Number.parseInt(AssetId as string),
	});

	const resp = await apiService.callV2("[MMS].[GetAssetResources]", parameters);
	return resp;
};
export const getWorkOrderResources = async (WorkOrderId: number | string) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [];
	parameters.push({ name: "WorkOrderId", value: WorkOrderId });

	const resp = await apiService.callV2("[MMS].[GetWorkOrderResources]", parameters);
	return resp;
};

export const getWorkOrderAttachments = async (WorkOrderId: number | string) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [];
	parameters.push({ name: "WorkOrderId", value: WorkOrderId });

	const resp = await apiService.callV2("[MMS].[GetWorkOrderAttachments]", parameters);
	return resp;
};


export const linkWorkOrderAttachments = async (
	WorkOrderId: number | string,
	Attachments: string,
) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [];
	parameters.push({ name: "WorkOrderId", value: WorkOrderId });
	parameters.push({ name: "Attachments", value: Attachments });

	const resp = await apiService.callV2("[MMS].[LinkWorkOrderAttachments]", parameters);
	return resp;
};

export const unlinkWorkOrderAttachments = async (
	WorkOrderId: number | string,
	Attachments: string,
) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [];
	parameters.push({ name: "WorkOrderId", value: WorkOrderId });
	parameters.push({ name: "Attachments", value: Attachments });

	const resp = await apiService.callV2("[MMS].[UnlinkWorkOrderAttachments]", parameters);
	return resp;
};
